<template>
	<div class="consent-box">
		<h2 class="title text-center">生涯辅导知情同意书</h2>
		<p class="mt10">1.生涯辅导每次为1小时左右，最长不超过1.5小时。</p>
		<p class="mt10">2.保密原则及其局限性：咨询师承诺，未经客户同意，不会泄露客户的资料，出现下列情况之一者，我们将不负有保密义务：</p>
		<p> （1）如果客户对其本人或他人的生命形成危险；</p>
		<p> （2）如果客户触犯国家法律，对其不法行为咨询师有权利接受司法部门的询问。</p>
		<p class="mt10">3.咨询的过程和内容（咨询记录）如个别有代表性、有教育意义、有研究意义的案例需经过客户同意，才会在教学中使用。（隐去客户姓名，工作单位，并做技术化处理）。</p>
		<p class="mt10">4.在要求咨询师保守有关秘密的同时，客户有义务保守相关的秘密，包括咨询师的个人信息，咨询过程中所使用工具、技术等。</p>
		<p class="mt10">双方本着平等自愿的原则达成以上约定，客户已阅读并理解了上述信息，同意参加职业生涯辅导。</p>
		<!--  -->
		<div class="fixed-btn">
			<div class="auto-pd20">
				<router-link class="button" to="/totoring_consent_need">我已同意</router-link>
			</div>
		</div>
	</div>
</template>
<script>
import { shareCon } from "@/utils/wxconfig";
	export default {
		data(){
			return {

			}
		},
		created() {
			shareCon("totoring",this);
		},
	}
</script>
<style lang="scss" scoped>
	@import "@s/remChange.scss";
	.consent-box{
		padding: 20px;
		padding-bottom: 100px;
		h2.title{
			color: #EB5032;
    	font-size: changeRem(0.68)+px;
		}
		p{
	    color: #666;
	    font-size: changeRem(0.56)+px;
	    line-height: changeRem(0.8)+px;
	    text-align: justify;
		}
		.mt10{
			margin-top: changeRem(0.6)+px;
		}
	}
	.fixed-btn{
		position: fixed;
		bottom: 0;
		right: 0;
		left: 0;
		background: #f0f0f0;
		box-shadow: 0 0 0.16rem rgba(245,127,23,.2);
		bottom: 0;
		.auto-pd20{
			padding: 20px 0;
		}
		.button{
			display: block;
	    margin: 0 auto;
	    text-align: center;
	    width: changeRem(11.56)+px;
	    height: changeRem(1.6)+px;
	    line-height: changeRem(1.6)+px;
	    border: none;
	    font-size: changeRem(0.68)+px;
	    color: #fff;
	    background: rgba(235, 80, 50, 1);
	    border-radius: changeRem(0.16)+px;
		}
	}
</style>